/** @format */

import {add, endOfDay, getDate, lastDayOfMonth, startOfDay, startOfMonth} from 'date-fns';

import {Period} from '../model';
import getPeriodDays from './getPeriodDays';

interface Props {
  defaultStartDate?: Date;
  defaultEndDate?: Date;
  period: Period;
  now?: Date;
}

interface Dates {
  startDate: Date;
  endDate: Date;
}

/**
 * Вернёт пересчитанные начало и конец периода на основе установленного периода.
 * Если период текущий, то вернет текущий месяц с первое по последнее число.
 * Если период текущий и сегодня первое число, то вернет период с первого числа прошлого месяца по сегодня.
 * Если период исторический, то датой окончания является вчера.
 * Если период кастомный, то вернёт либо дефолтные даты, либо сегодня.
 * Дефолтные начало и конец даты имеют приоритет над всей остальной логикой.
 * @param defaultStartDate
 * @param defaultEndDate
 * @param period
 */

const getNewDates = ({defaultStartDate, defaultEndDate, period, now}: Props): Dates => {
  if (period === 'custom') {
    return {
      startDate: startOfDay(defaultStartDate || new Date()),
      endDate: endOfDay(defaultEndDate || new Date()),
    };
  }

  let startDate: Date;
  let endDate: Date;
  const today = now || new Date();

  if (period == 'current') {
    if (getDate(today) === 1) {
      // Если сегодня === 1, то показываем период с первого числа прошлого месяца по сегодня.
      startDate = add(today, {months: -1});
      endDate = today;
    } else {
      // Показываем текущий месяц с первое по последнее число.
      startDate = startOfMonth(today);
      endDate = lastDayOfMonth(today);
    }
  } else {
    // Показываем исторический период, не включая сегодняшний день.
    endDate = add(today, {days: -1});
    const days = getPeriodDays(period, endDate);
    startDate = add(today, {days: -days});
  }

  return {
    startDate: startOfDay(defaultStartDate || startDate),
    endDate: endOfDay(defaultEndDate || endDate),
  };
};

export {getNewDates};
